import React, { useEffect, useRef, useState} from 'react';
import { FormattedDate } from 'react-intl';

import "./QuickStatsCollections.scss";
import {roundUp} from "../../utils/helpers";

const QuickStatsCollections = ({quickInfo, isOpenQuickStats, closeQuickStats, quickStatsButtonPosition}) => {

  const quickStatsCollections = useRef();

  const [quickStatsPosition, setQuickStatsPosition] = useState(null);

  useEffect(() => {
      const quickStatsCollectionsClientRect = quickStatsCollections.current?.getBoundingClientRect();
      const heightWindow = document.body.scrollHeight;

      const clientX = quickStatsButtonPosition?.right + 10;
      let clientY = quickStatsButtonPosition?.top - 20;

      if(heightWindow - quickStatsButtonPosition?.y < quickStatsCollectionsClientRect?.height) {
        clientY =  clientY - quickStatsCollectionsClientRect.height + 60;
      }

      setQuickStatsPosition({clientX, clientY});

  }, [isOpenQuickStats]);

  useEffect(() => {

    const checkElement = (event) => {
      const currentElement = event.target;
      const quickStatsElement = quickStatsCollections.current;

     if(!quickStatsElement?.contains(currentElement)) {
        closeQuickStats();
      }
    }

    document.addEventListener('click', (event) => checkElement(event));

    return(
      document.removeEventListener('click', (event) => checkElement(event))
    )
  }, []);

  const {creationTime, descreption: description, parameters, quickData} = quickInfo;

  return (
    <div className="quick-stats-collections-wrapper">
      {
        isOpenQuickStats &&
        <div className="quick-stats-collections" ref={quickStatsCollections}
             style={{top: quickStatsPosition?.clientY + "px", left: quickStatsPosition?.clientX + "px"}}>
        <div className="quick-stats-collections__wrapper">
          <div className="quick-stats-collections__header">Created</div>
          <FormattedDate day="2-digit" year="numeric" month="2-digit" hour="numeric" minute="numeric" second="numeric" hour12={false} value={creationTime} />
        </div>
        <div className="quick-stats-collections__wrapper">
          {
            quickData.map((el) => {
              return(
                <div key={el.name} className="quick-stats-collections__numbers">
                  <span className="quick-stats-collections__header">{`${el.name}: `}</span>
                  <span className="quick-stats-collections__info">{`${roundUp(el.value)} ${el.unit ? el.unit: ""}`}</span>
                </div>
              )
            })
          }
        </div>
        {
          !!parameters.length &&
            <div className="quick-stats-collections__wrapper">
              <div className="quick-stats-collections__header">Parameters</div>
              <div className="quick-stats-collections__info">
                {
                  parameters.map((parameter, index) => {
                    if(parameters.length - 1 === index) {
                      return parameter
                    } else {
                      return parameter + ", "
                    }
                  })
                }
              </div>
            </div>
        }
        {
          description &&
            <div className="quick-stats-collections__wrapper">
              <div className="quick-stats-collections__header">Description</div>
              <div className="quick-stats-collections__info">{description}</div>
            </div>
        }
      </div>
      }
    </div>
  );
};

export default QuickStatsCollections;